export const build = { date:"2026-08-18.1257", stage:"alpha" }
